import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close, ErrorOutlineOutlined } from '@mui/icons-material';
import { useResolutionPdfUrls } from './useResolutionPdfUrls';

const DIALOG_HEIGHT = '92vh';
const BODY_HEIGHT = `calc(${DIALOG_HEIGHT} - 70px)`;

const EmployeeResolutionViewer = ({
  open,
  onClose,
  storagePaths = [],
  ready = true,
  error: prepareError = false,
  errorMessage = '',
  retryable = false,
  onRetry,
}) => {
  const { pdfUrls, loadError, loadedCount, onIframeLoad } = useResolutionPdfUrls({
    open,
    ready,
    storagePaths,
  });

  const hasError = prepareError || loadError;
  const isLoading = !hasError && (pdfUrls.length === 0 || loadedCount < pdfUrls.length);
  const canRetry = !!onRetry && (retryable || loadError);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { height: DIALOG_HEIGHT } }}
    >
      <DialogTitle>
        Decision on annual leave
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
          size="large"
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          p: 0,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: BODY_HEIGHT,
          }}
        >
          {hasError ? (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                p: 3,
                textAlign: 'center',
              }}
            >
              <ErrorOutlineOutlined color="error" sx={{ fontSize: 48 }} />
              <Typography color="error">
                {errorMessage || 'Error loading document. Please try again.'}
              </Typography>
              {canRetry && (
                <Button variant="outlined" onClick={onRetry}>
                  Try again
                </Button>
              )}
            </Box>
          ) : (
            <>
              {isLoading && (
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: 'background.paper',
                    zIndex: 1,
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
              {pdfUrls.map((url, index) => (
                <iframe
                  key={url}
                  src={`${url}#zoom=page-fit`}
                  title={`Decision on annual leave ${index + 1}`}
                  onLoad={onIframeLoad}
                  style={{
                    width: '100%',
                    height: BODY_HEIGHT,
                    border: 'none',
                    display: 'block',
                    borderTop: index > 0 ? '2px solid #e0e0e0' : 'none',
                  }}
                />
              ))}
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EmployeeResolutionViewer;
